import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as BsIcons from "react-icons/bs";

export const ICONS = { ...FaIcons, ...AiIcons, ...BsIcons };

export const renderSpecIcon = ({ iconName, iconClass, styles }) => {
  if (iconName && typeof iconName === "string") {
    const Icon = ICONS[iconName.trim()];
    if (Icon) {
      return <Icon className={styles.specIcon} />;
    }
  }

  if (iconClass) {
    return <i className={iconClass} aria-hidden="true" />;
  }

  return <span className={styles.specDot} />;
};

export const getDimensionScoreTier = (score) => {
  const normalized = Math.min(100, Math.max(0, Number(score) || 0));
  if (normalized >= 80) return "success";
  if (normalized >= 60) return "warning";
  return "error";
};

export const getDimensionBarClass = (score, styles) => {
  const tier = getDimensionScoreTier(score);
  if (tier === "success") return styles.dimensionBarSuccess;
  if (tier === "warning") return styles.dimensionBarWarning;
  return styles.dimensionBarError;
};

export const capitalizeLeadingLetter = (value) => {
  if (typeof value !== "string" || value.length === 0) return value;
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

export const formatSpecValue = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (Array.isArray(value)) {
    return value.join(", ");
  }
  if (typeof value === "object" && value !== null) {
    return Object.values(value).join(" ");
  }
  return String(value);
};

const HEX_COLOR_RE = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const CSS_FUNCTION_COLOR_RE = /^(?:rgb|rgba|hsl|hsla)\(/i;

export const extractCssColor = (value) => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (HEX_COLOR_RE.test(trimmed) || CSS_FUNCTION_COLOR_RE.test(trimmed)) {
    return trimmed;
  }
  return null;
};

export const extractCssColors = (value) => {
  if (Array.isArray(value)) {
    return value.map(extractCssColor).filter(Boolean);
  }
  const color = extractCssColor(value);
  return color ? [color] : [];
};

export const renderSpecValue = (value, { styles, type } = {}) => {
  const colors = extractCssColors(value);
  const namedColor =
    colors.length === 0 &&
    type === "color" &&
    typeof value === "string" &&
    value.trim()
      ? [value.trim()]
      : [];
  const swatches = colors.length > 0 ? colors : namedColor;

  if (swatches.length > 0 && styles?.specColorSwatch) {
    return (
      <span className={styles.specColorSwatches}>
        {swatches.map((color, index) => (
          <span
            key={`${color}-${index}`}
            className={styles.specColorSwatch}
            style={{ backgroundColor: color }}
            title={color}
            aria-label={color}
          />
        ))}
      </span>
    );
  }

  return formatSpecValue(value);
};
